/**
 * @file コンポーネント：検索機能付きフォームプルダウン DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Modal } from "~/src/components/projects/Modal";
import { InputText } from "~/src/components/uiparts/InputText";

// スタイル読み込み
import {
    StyledPulldown,
    StyledPulldownModal,
    StyledPulldownSearchlist,
    StyledPulldownSearchlistItem,
    StyledPulldownSelect,
    StyledPulldownSelected,
    StyledPulldownSelectOption,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <>
            {props.list.length > 0 && (
                <StyledPulldown
                    className={props.isWide === true && "is-wide"}
                    data-on-color={props.onColor}
                >
                    {/* 選択中の項目 */}
                    <StyledPulldownSelected
                        data-on-color={props.onColor}
                        onClick={() => props.setIsOpen(!props.isOpen)}
                    >
                        {props.textSelected}
                    </StyledPulldownSelected>
                    {/* モーダル */}
                    <Modal
                        content={[
                            <StyledPulldownModal
                                key="modal"
                                onMouseMove={(e) => props.fnOnMouseMove(e)}
                            >
                                {/* 検索フィールド */}
                                <InputText
                                    isWide={true}
                                    onInput={(e) => props.fnOnInputSearch(e)}
                                    refInputText={props.refSearch}
                                    type="text"
                                />
                                {/* 検索候補リスト */}
                                <StyledPulldownSearchlist
                                    ref={props.refSearchlist}
                                >
                                    {props.list.map((item, index) => (
                                        <StyledPulldownSearchlistItem
                                            data-value={item.value}
                                            key={"option-" + index}
                                            onClick={(e) =>
                                                props.fnOnClickSearchlistItem(e)
                                            }
                                            onMouseEnter={(e) =>
                                                props.fnOnMouseEnterSearchlistItem(
                                                    e,
                                                    props.isMouseMoved
                                                )
                                            }
                                        >
                                            {item.text}
                                        </StyledPulldownSearchlistItem>
                                    ))}
                                </StyledPulldownSearchlist>
                            </StyledPulldownModal>,
                        ]}
                        hasButtonClose={true}
                        isShow={props.isOpen}
                        setIsShow={props.setIsOpen}
                    />
                    {/* 本物のプルダウン（非表示） */}
                    <StyledPulldownSelect
                        defaultValue={props.value}
                        id={props.id}
                        name={props.name}
                        ref={props.refSelect}
                        title={props.title}
                    >
                        {props.list.map((item, index) => (
                            <StyledPulldownSelectOption
                                key={"option-" + index}
                                value={item.value}
                            >
                                {item.text}
                            </StyledPulldownSelectOption>
                        ))}
                    </StyledPulldownSelect>
                </StyledPulldown>
            )}
        </>
    );
};
